/** A project name as an npm package name: lowercase, dashes for anything else, `gotti-game` when nothing is left. */
export function sanitizePackageName(name: string): string {
  return name.trim().replace(/[^a-zA-Z0-9-_]+/g, '-').replace(/^-+|-+$/g, '').toLowerCase() || 'gotti-game';
}
